/**
 * Used for the impersonation API calls
 */
export enum LogOnType {
  /**
   * Invalid value
   */
  None = 0,

  /**
   * The security principal is logging on interactively.
   */
  LogOnInteractive = 2,

  /**
   * The security principal is logging using a network.
   */
  LogOnNetwork,

  /**
   * The logon is for a batch process.
   */
  LogOnBatch,

  /**
   * The logon is for a service account.
   */
  LogOnService,

  /**
   * The logon is a network logon with plaintext credentials.
   */
  LogOnNetworkClearText = 8,
}
